import React from "react";
import PropTypes from "prop-types";
import SortableHeader from "../../../../components/atoms/SortableHeader";
import { compareByProperty, compareByArrayProperty } from "./helpers";

const labels = {
  disease_name: "Disease Name",
  disgenet_id: "DisGeNET ID",
  source: "Source",
};

function FusionGdbDiseaseAssociationsTable({
  items,
  sortedField,
  isAsc,
  toggleField,
}) {
  return (
    <div
      className="tw-overflow-y-auto tw-ml-0 tw-mb-8"
      data-testid="fusion-gdb-disease-associations-table"
    >
      <table className="varsome-table varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="disease_name"
              width="40%"
              sort={(key) => toggleField(compareByProperty(key), key)}
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="disgenet_id"
              width="30%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByArrayProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="source"
              width="30%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((x) => {
            return (
              <tr key={x.disease_name}>
                <td data-testid="fusion-gdb-disease-name">{x.disease_name}</td>
                <td data-testid="fusion-gdb-disgenet-id">
                  <a
                    target="_blank"
                    href={`https://www.disgenet.org/search/0/${x.disgenet_id}`}
                  >
                    {x.disgenet_id}
                  </a>
                </td>
                <td data-testid="fusion-gdb-disease-sources">
                  {x.source &&
                    Array.isArray(x.source) &&
                    (x.source.length === 1 ? (
                      <span>{x.source}</span>
                    ) : (
                      x.source.map((s) => {
                        return (
                          <span key={s}>
                            {s}
                            <br />
                          </span>
                        );
                      })
                    ))}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

FusionGdbDiseaseAssociationsTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      disease_name: PropTypes.string,
      disgenet_id: PropTypes.string,
      source: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
};

FusionGdbDiseaseAssociationsTable.defaultProps = {
  items: null,
  sortedField: null,
  isAsc: true,
};
export default FusionGdbDiseaseAssociationsTable;
